/* @indexer:no-export */
import * as React from 'react';
import './TableHead.css';
import TableGroup from '../TableGroup/TableGroup';
import Sticky from '../../Stickyfill/Stickyfill';
import { getAdditionalProps } from '../utils';
export var getTheadProps = getAdditionalProps('dm-table__header', function (state, rowInfo, column, _ref) {
  var props = _ref.props;
  return {
    adjustSticky: props.adjustSticky,
    sticksTo: props.sticksTo
  };
});
export default function TableHead(_ref2) {
  var className = _ref2.className,
    children = _ref2.children,
    sticksTo = _ref2.sticksTo,
    adjustSticky = _ref2.adjustSticky;
  if (sticksTo) {
    return /*#__PURE__*/React.createElement(Sticky, {
      sticksTo: sticksTo,
      adjust: adjustSticky
    }, function (ref) {
      return /*#__PURE__*/React.createElement(TableGroup, {
        ref: ref,
        className: className
      }, children);
    });
  } else {
    return /*#__PURE__*/React.createElement(TableGroup, {
      className: className
    }, children);
  }
}